import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) { }

    async canActivate(route: import('@angular/router').ActivatedRouteSnapshot, state: import('@angular/router').RouterStateSnapshot): Promise<boolean | UrlTree> {
        // If no OAuth/Keycloak is configured, allow access (dev mode without auth)
        const orionUrl = (environment as any).orionUrl;
        if (!orionUrl) {
            console.warn('AuthGuard: No orionUrl configured, allowing access without authentication');
            return true;
        }

        // First check if we are already authenticated synchronously (fast path)
        if (this.authService.isAuthenticated()) {
            return true;
        }

        // Check if a login/init process is finishing
        const isLoggedIn = await this.authService.tryLogin();
        if (isLoggedIn) {
            return true;
        }

        // If not logged in, redirect to login
        const returnUrl = state.url;
        console.log('AuthGuard: Access denied, redirecting to login with returnUrl:', returnUrl);
        this.authService.login(returnUrl);
        return false;
    }
}
